import { login, logout, updateUser } from '../reducers/session.reducer';

const Session = {
  Login: login,
  Logout: logout,
  UpdateUser: updateUser,
};

export default Session;
